module.exports = __webpack_public_path__ + "static/media/hero-payer-faq.6cee0d57.png";